// English strings for P5-A (PRODUCT, MEDIA, SEARCH) (D-013: English only). Owned by that worker; spread into `en` as
// `en.catalog`, so keys read `t("catalog.…")`. Copy rules: DESIGN_SYSTEM §9.6.
export const catalogStrings = {
  products: {
    title: "Products",
    lead: "Everything you sell online and at the counter.",
    add: "Add product",
    searchHint: "Search products…",
    sections: { label: "Catalog sections", products: "Products", reviews: "Reviews" },
    statusLabel: "Product status",
    moreActions: "More product actions",
    detail: {
      close: "Close",
      edit: "Edit product",
      dates: "Added {created} · Last edited {updated}",
      price: "Price",
      onSale: "On sale",
      cost: "Cost",
      margin: "{percent}% margin",
      stock: "Stock",
      backorder: "Sells at zero stock",
      untracked: "Not tracked",
      variants: "Variants",
      brand: "Brand",
      categories: "Categories",
      sellOn: "Sold on",
      tags: "Tags",
      delivery: "Delivery",
      freeDelivery: "Free delivery",
      standardDelivery: "Store delivery charges",
      release: "Release date",
      option: "Option",
      sku: "Item code",
      off: "off",
      description: "Description",
      features: "Features and specs",
      search: "Search preview",
      noSeo: "No description yet.",
    },
    rowMenu: {
      label: "Actions for {title}",
      viewWebsite: "View on your website",
      groupView: "View",
      groupEdit: "Edit",
      groupManage: "Manage",
      pillWebsite: "Website",
      pillQuick: "Quick buy",
      price: "Price and inventory",
      fields: "Custom fields",
      quickPurchase: "View quick purchase",
      quickFailed: "This product has no option to buy yet.",
      notOnStore: "Only active products sold on the website have a store page.",
      bundle: "Bundle items",
      bundleSoon: "Bundles (sell several products as one) are coming soon.",
      bundleTitle: "Bundle items: {title}",
      design: "Page design",
      designTitle: "Page design: {title}",
      designSoon: "A different product page layout for one product is coming soon.",
      designToday: "Today every product uses your theme's product page.",
      designView: "View product page",
      layouts: {
        standard: "Standard",
        standardBody: "Photos beside details",
        wide: "Wide gallery",
        wideBody: "Large photos on top",
        story: "Story",
        storyBody: "Long description first",
      },
      bundlePoints: {
        pick: "Pick the products that go in the bundle and how many of each.",
        price: "Set one bundle price; buyers see what they save.",
        stock: "Each sale takes stock from every product in the bundle.",
      },
      bundleMeanwhile:
        "Until then, show products together as similar products on the product page.",
      bundleSimilar: "Set similar products",
      deleteHeading: "Delete product",
      deleteConfirm: "Delete product",
      deletePoints: {
        gone: "It's removed from your store, lists and search.",
        orders: "Past orders and reports keep their details.",
        undo: "This can't be undone.",
      },
      archiveHint:
        "Not selling it any more? Archive keeps it for your records and takes it off sale.",
      archiveInstead: "Archive instead",
      archived: "{title} archived",
      seoImage: "Share image",
      seoImageCover: "Cover photo",
      seoNoPhotos: "Add photos to the product to choose a share image.",
      soon: "Soon",
      status: "Update status",
      seo: "Update SEO metadata",
      duplicate: "Duplicate product",
      duplicated: "Copied as {title}",
      danger: "Danger zone",
      delete: "Delete",
      deleteTitle: "Delete {title}?",
      deleteBody: "It's removed from your store and lists. Past orders keep their details.",
      deleted: "{title} deleted",
      close: "Close",
      cancel: "Cancel",
      save: "Save",
      current: "current",
      statusSaved: "{title} is now {status}",
      statusHelp: {
        active: "On sale wherever it's listed.",
        draft: "Hidden while you work on it.",
        unlisted: "Sold by direct link only; not in lists or search.",
        archived: "Kept for records; not for sale.",
      },
      loading: "Loading…",
      seoTitle: "Page title",
      seoDescription: "Description",
      seoDescriptionPh: "A short summary for search results",
      seoPreview: "Search preview",
      seoHint: "Empty fields use the product name and description.",
      seoSaved: "SEO for {title} saved",
    },
    more: {
      categories: "Categories",
      collections: "Collections",
      brands: "Brands",
      inventory: "Inventory",
      importExport: "Import and export",
    },
    hash: "#",
    name: "Name",
    open: "Open {title}",
    searchLabel: "Search products",
    searchPlaceholder: "Name, SKU or barcode",
    tabs: {
      all: "All",
      active: "Active",
      draft: "Draft",
      unlisted: "Unlisted",
      archived: "Archived",
    },
    tableCaption: "Products",
    columns: {
      product: "Product",
      status: "Status",
      price: "Price",
      variants: "Variants",
      cost: "Cost",
      quality: "Listing quality",
      updated: "Updated",
    },
    variantCount: { one: "{count} variant", other: "{count} variants" },
    priceRange: "{min} – {max}",
    quality: "{score}%",
    noImage: "No photo",
    emptyTitle: "Add your first product",
    emptyBody: "Products appear in your online store and at the counter once they are active.",
    noResultsTitle: "No products match",
    noResultsBody: "Try another name, SKU or barcode, or clear the filter.",
    clearFilter: "Clear filter",
    loadMore: "Show more",
    selected: { one: "{count} product selected", other: "{count} products selected" },
    clearSelection: "Clear selection",
    status: {
      draft: "Draft",
      active: "Active",
      unlisted: "Unlisted",
      archived: "Archived",
    },
    channels: { web: "Online store", pos: "Counter (POS)", headless: "Other sales apps" },
    posOnly: "Counter only",
  },
  bulk: {
    button: "Bulk edit",
    title: { one: "Edit {count} product", other: "Edit {count} products" },
    lead: "The change runs in the background. You'll see the result for each product.",
    actionLabel: "Change",
    actions: {
      set_status: "Set status",
      set_price: "Adjust price",
      add_tags: "Add tags",
      remove_tags: "Remove tags",
    },
    statusLabel: "New status",
    priceMode: "How",
    priceModes: { percent: "By percent", delta: "By amount", set: "Set exact price" },
    percentLabel: "Percent (use minus for a discount)",
    amountLabel: "Amount",
    tagsLabel: "Tags",
    tagsHelp: "Separate tags with commas.",
    submit: "Start bulk edit",
    submitting: "Starting…",
    started: "Bulk edit started",
    resultTitle: "Bulk edit",
    progress: "{done} of {total} done",
    resultDone: "{ok} updated, {failed} failed",
    running: "Running…",
    failedItem: "Failed: {code}",
    close: "Close",
    invalid: "Fill in the change first.",
  },
  editor: {
    steps: {
      label: "Product steps",
      step: "Step {n}",
      general: "General information",
      variants: "Variants and inventory",
      custom: "Custom fields",
      next: "Next: {step}",
    },
    newTitle: "Add product",
    editTitle: "Edit product",
    back: "Back to products",
    save: "Save",
    saving: "Saving…",
    saved: "Product saved",
    created: "Product added",
    duplicate: "Duplicate",
    duplicated: "Copy created as a draft",
    delete: "Delete",
    deleteTitle: "Delete {title}?",
    deleteBody:
      "It disappears from your store and the counter. Orders that include it keep their details.",
    deleted: "Product deleted",
    readOnly: "You can view this product, but only staff with product permissions can change it.",
    conflict: "Someone else changed this product. Reload to see their changes, then edit again.",
    reload: "Reload",
    notFound: "This product doesn't exist or was deleted.",
    sections: {
      basics: "Basics",
      media: "Photos",
      variants: "Price and options",
      personalization: "Buyer personalisation",
      organization: "Organisation",
      visibility: "Visibility",
      shipping: "Stock and shipping",
      seo: "Search engine listing",
    },
    titleLabel: "Name",
    titleRequired: "Enter a name.",
    descriptionLabel: "Description",
    descriptionHelp: "Plain text. Each blank line starts a new paragraph.",
    statusLabel: "Status",
    statusHelp: {
      draft: "Only your team can see it.",
      active: "Shoppers and the counter can see it.",
      unlisted: "Reachable by link, not shown in lists.",
      archived: "Hidden everywhere; kept for history.",
    },
    channelsLabel: "Where it's sold",
    channelsNone: "Pick at least one place to sell it.",
    purchaseLabel: "Buy button",
    purchase: {
      buy: "Buy now",
      coming_soon: "Coming soon",
      price_on_request: "Price on request",
      external: "Link to another site",
    },
    externalUrlLabel: "External link",
    externalUrlHelp: "Starts with https://",
    categoriesLabel: "Categories",
    categoriesEmpty: "No categories yet. Add them under Products › Categories.",
    brandLabel: "Brand",
    brandNone: "No brand",
    tagsLabel: "Tags",
    tagsHelp: "Separate tags with commas. Collections can pick products by tag.",
    trackInventory: "Track stock",
    trackInventoryHelp:
      "Shoppers see in stock, low or out of stock. Stock levels are set under Inventory.",
    allowBackorder: "Keep selling when out of stock",
    taxLabel: "VAT",
    tax: { standard: "Standard rate", exempt: "Exempt", zero: "Zero-rated" },
    seoTitle: "Page title",
    seoDescription: "Meta description",
    seoHelp: "Shown by search engines. Leave empty to use the name.",
    qualityTitle: "Listing quality {score}%",
    qualityHelp:
      "A name of 10+ characters, a description, 3 photos, a category and SKUs help shoppers find it.",
  },
  add: {
    title: "Add product",
    editTitle: "Edit product",
    saveChanges: "Save changes",
    saving: "Saving…",
    saved: "{title} saved",
    videoName: "Video {n}",
    close: "Close",
    back: "Back",
    next: "Next step",
    submit: "Add product",
    submitting: "Adding…",
    created: "{title} added",
    stockFailed: "Product added, but its stock wasn't set. Set it under Inventory.",
    secProduct: "Product",
    nameLabel: "Product name",
    secMedia: "Photos and videos",
    videoLinkLabel: "Video link",
    secSell: "Where it's sold",
    secOrganise: "Brand and categories",
    secDescription: "Description",
    secPhotos: "Photos",
    secPrice: "Price",
    secStock: "Stock and shipping",
    secVariants: "Variants",
    secTags: "Tags and similar products",
    secSimilar: "Similar products",
    secCustom: "Buyer custom fields",
    secFeatures: "Key features",
    secSpecs: "Specifications",
    secSeo: "Search engine listing",
    secDiscovery: "Tags and discovery",
    secCheckout: "At checkout",
    secPage: "Product page",
    paymentsLabel: "Payment methods for this product",
    payHide: "Hide this method for this product",
    payShow: "Offer this method again",
    paymentsAll: "All methods are offered. Tap one to hide it when this product is in the cart.",
    paymentsHidden: {
      one: "{count} method is hidden when this product is in the cart.",
      other: "{count} methods are hidden when this product is in the cart.",
    },
    addSpecShort: "Add row",
    specGroupCol: "Group (optional)",
    specNameCol: "Name",
    specValueCol: "Value",
    specGroupShortPh: "e.g. Fabric",
    specNameShortPh: "e.g. Material",
    specValueShortPh: "e.g. 100% cotton",
    seoTitleShortPh: "Uses the product name when empty",
    seoDescriptionShortPh: "Uses the description when empty",
    namePh: "Product name, e.g. Red cotton kurta",
    nameRequired: "Enter the product name.",
    photoRequired: "Add at least one photo.",
    channels: { all: "Everywhere", web: "Online store", pos: "Counter (POS)" },
    channelsHelp: {
      all: "Shown in your online store and at the counter.",
      web: "Only in your online store.",
      pos: "Only at the counter. A photo and description are optional.",
    },
    brandNone: "No brand",
    addBrand: "Add",
    newBrandPh: "New brand name",
    categoriesNone: "No categories yet. Add one.",
    addCategory: "Add",
    newCategoryPh: "New category name",
    save: "Save",
    cancelAdd: "Cancel",
    added: "{name} added",
    descriptionPh: "Describe the product: what it is, what it's made of, sizes and care.",
    tipsTitle: "A description that sells:",
    tips: {
      problem: "Says which problem it solves for the buyer.",
      plain: "Uses plain, simple words.",
      benefits: "Lists the main features and benefits.",
      picture: "Helps the buyer picture using it.",
    },
    chars: "{count} characters",
    photosHelp: "Up to 15 MB.",
    photosTip: "The first photo is the cover. JPEG, PNG, WebP or AVIF.",
    cover: "Cover",
    makeCover: "Make cover",
    uploadTile: "Upload",
    fromLibrary: "From library",
    removePhoto: "Remove photo",
    variantsSwitch: "This product has variants",
    variantsSwitchHelp: "Turn on when it comes in several colours, sizes or styles.",
    optionNamePh: "Option name",
    optionValuesPh: "Type a value and press Enter",
    optionDefaults: { first: "Color", second: "Size" },
    removeOption: "Remove option {name}",
    removeValue: "Remove {value}",
    maxOptions: "Up to 3 options.",
    generateSkus: "Generate SKUs",
    generateSku: "Generate SKU",
    showCodes: "Barcode and HS code (optional)",
    hideCodes: "Hide barcode and HS code",
    noCombos: "Add option values above to list the variants.",
    variantCol: "Variant",
    removeVariant: "Don't sell {title}",
    restoreVariant: "Sell {title} again",
    removedCount: {
      one: "{count} variant not sold. Restore all",
      other: "{count} variants not sold. Restore all",
    },
    crossedPrice: "Crossed price",
    sellingPrice: "Selling price",
    costPrice: "Cost price",
    quantity: "Quantity",
    weightKg: "Weight (kg)",
    weight: "Weight",
    kg: "kg",
    sku: "SKU",
    barcode: "Barcode",
    hsCode: "HS code",
    priceRequired: "Enter a selling price.",
    pricesRequired: "Enter a selling price for every variant.",
    noVariants: "Add at least one variant, or turn variants off.",
    crossedLow: "The crossed price should be higher than the selling price.",
    weightInvalid: "Enter the weight in kg, e.g. 0.5.",
    hsInvalid: "An HS code has 4 to 10 digits.",
    qtyInvalid: "Enter a whole number.",
    qtyNoPermission: "Stock is set under Inventory by staff with stock permission.",
    track: "Track stock",
    unlimited: "Unlimited",
    stockLabel: "Stock",
    trackHelp: {
      on: "Counts stock; selling stops at zero unless “Sell at zero stock” is on.",
      off: "Always available; stock isn't counted.",
    },
    backorderHelp: "Buyers can still order at zero stock; you fulfil once restocked.",
    backorderShort: "Sell at zero stock",
    taxHelp: {
      standard: "Your store's VAT rate applies at checkout.",
      exempt: "No VAT is charged on this product.",
      zero: "VAT at 0%; still reported in your VAT returns.",
    },
    tax: "VAT",
    tagsPh: "Type a tag and press Enter",
    tagsHelp: "Collections can pick products by tag.",
    similarPh: "Search products to show as similar",
    similarHelp: "Shown under the product in your store.",
    similarEmpty: "No products match.",
    customSwitch: "Ask buyers for details",
    customSwitchHelp:
      "For example a name to engrave or a photo to print. Answers come with the order.",
    fieldLabelPh: "Question, e.g. Name to print",
    fieldChoicesPh: "Choices, separated by commas",
    fieldRequired: "Required",
    fieldSurcharge: "Extra charge",
    addField: "Add a question",
    removeField: "Remove question",
    fieldLabelRequired: "Write the question for every field, or remove it.",
    featuresPh: "A selling point, e.g. 100% cotton",
    addFeature: "Add feature",
    remove: "Remove",
    seoPreview: "Search result preview",
    seoCount: "{count} / {max}",
    statusLabel: "Status",
    statuses: { active: "Published", draft: "Draft", unlisted: "Unlisted", archived: "Archived" },
    statusHelp: {
      active: "Visible to buyers.",
      draft: "Only your team can see it.",
      unlisted: "Only reachable by its link.",
      archived: "Kept for records; not for sale.",
    },
    quality: "Product quality {score}/100",
    qualityHelp: "Guidance only. It never blocks publishing.",
    qualityChecks: {
      name: "A name of 10 or more characters",
      description: "A description of 50 or more characters",
      photo: "At least one photo",
      photos: "Three or more photos",
      category: "A category",
      sku: "A SKU on every variant",
      weight: "A weight on every variant",
      seo: "An SEO title and meta description",
    },
    summary: "Summary",
    summaryPrice: "Price",
    summaryVariants: "Variants",
    summaryPhotos: "Photos",
    summaryStock: "Stock",
    untracked: "Not tracked",
    secPriceStock: "Price and stock",
    secDelivery: "Stock, tax and delivery",
    tipsToggle: "Writing tips",
    delivery: "Delivery charges",
    deliveryDefault: "Store default",
    deliveryHelp: "Delivery presets are set under Apps › Courier accounts › Delivery.",
    variantPhoto: "Photo for {title}",
    variantPhotoNone: "No photo (uses the cover)",
    variantPhotoNeed: "Add photos in step 1 first.",
    choosePhoto: "Choose photo for {title}",
    seoImage: "Share image",
    seoImageHelp: "Shown when the link is shared on social media. Leave empty to use the cover.",
    seoImageCover: "Use the cover",
    qualityLeft: { one: "{count} thing to improve", other: "{count} things to improve" },
    qualityDone: "Everything looks good.",
    writeAi: "Write with AI",
    writingAi: "Writing…",
    aiInactive: "AI writing isn't active yet. It starts working once Workers AI is switched on.",
    aiNeedsName: "Enter the product name first.",
    aiDone: "Draft added. Check it before you publish.",
    longDescription: "Long description (optional)",
    longDescriptionPh: "Details, size guide, care, warranty… shown lower on the product page.",
    addLongDescription: "Add a long description",
    videoUrl: "YouTube, Vimeo or another https link",
    videoInvalid: "A video link starts with https://",
    secVideos: "Videos",
    videoUploadTile: "Upload video",
    videosHelp: "Up to 50 MB each.",
    videosTip: "MP4, WebM or MOV. Up to 3 videos; they play after the photos.",
    videoPreparing: "Preparing…",
    videoUploading: "{percent}%",
    videoFinishing: "Checking…",
    videoCancel: "Cancel upload",
    videoTooLarge: "{name} is larger than 50 MB. Trim or compress it, then try again.",
    videoType: "{name} isn't an MP4, WebM or MOV video.",
    videoFailed: "{name} couldn't be uploaded.",
    videoMax: "You can add up to 3 videos.",
    videoPlay: "Play {name}",
    videoRemove: "Remove video",
    videoPreview: "Video preview",
    videoNoPoster: "No preview",
    photoUploadingCount: {
      one: "Wait for the photo to finish uploading.",
      other: "Wait for the photos to finish uploading.",
    },
    videoUploadingCount: {
      one: "Wait for the video to finish uploading.",
      other: "Wait for the videos to finish uploading.",
    },
    swatchesToggle: "Colour preview",
    swatchFor: "Colour for {value}",
    swatchNone: "No colour",
    swatchSplit: "Two colours",
    swatchFirst: "Colour 1",
    swatchSecondTab: "Colour 2",
    swatchSystem: "Open the colour picker",
    swatchHex: "Hex code",
    swatchHexBad: "Use a hex code like #C0392B or C33.",
    swatchEyedropper: "Pick a colour from the screen",
    swatchPresets: "Common colours",
    swatchClear: "Remove colour",
    swatchDone: "Done",
    optionCol: "Option",
    valuesCol: "Values",
    addOptionShort: "Add option",
    colourValuesPh: "Type a colour or a hex code (#1F6F43), then Enter",
    colourAdd: "Add a colour",
    colourName: "Name",
    colourNamePh: "e.g. Forest Green",
    colourAddButton: "Add",
    altBarcodes: "Extra barcodes",
    altBarcodesPh: "Scan or type, then Enter",
    altBarcodesCellPh: "Separate with commas",
    altBarcodesHelp: "For packs or supplier codes. A scan at the counter finds this item too.",
    freeDeliveryHelp: "Checkout charges no delivery for it (other items still pay).",
    deliveryTimeLabel: "Delivery time",
    deliveryTimeHelp: "Shown to buyers on the product page.",
    deliveryTimePh: "e.g. 2–3 days",
    freeDeliveryShort: "Free delivery",
    installationManageShort: "Manage",
    courier: "Preferred courier",
    courierNone: "Auto (store rules)",
    courierHelp: "Used when every item of an order prefers the same connected courier.",
    couriers: { pathao: "Pathao", ncm: "Nepal Can Move", stub: "Test courier" },
    installation: "Installation service",
    installationNone: "No installation",
    releaseDate: "Release date",
    releaseDateShort: "Sets the “newest” order.",
    releaseDateHelp: "Orders “newest” in your store. Leave empty to use the publish date.",
    featuresHeadingPh: "Heading above the list, e.g. Why you'll love it",
    fieldPlaceholderPh: "Hint inside the box (optional)",
  },
  rich: {
    title: "Long description",
    subtitle: "Shown lower on the product page, under the main description.",
    placeholder:
      "Write the details: size guide, materials, care, warranty… Add photos and tables where they help.",
    editorLabel: "Long description text",
    toolbar: "Formatting",
    blockStyle: "Text style",
    blocks: {
      p: "Paragraph",
      h2: "Heading",
      h3: "Subheading",
      h4: "Small heading",
      blockquote: "Quote",
      pre: "Code block",
    },
    undo: "Undo (Ctrl+Z)",
    redo: "Redo (Ctrl+Y)",
    bold: "Bold (Ctrl+B)",
    italic: "Italic (Ctrl+I)",
    underline: "Underline (Ctrl+U)",
    strike: "Strikethrough",
    sub: "Subscript",
    sup: "Superscript",
    textColor: "Text colour",
    highlight: "Highlight",
    customColor: "Custom colour",
    noHighlight: "No highlight",
    alignLeft: "Align left",
    alignCenter: "Centre",
    alignRight: "Align right",
    alignJustify: "Justify",
    bullets: "Bulleted list",
    numbers: "Numbered list",
    indent: "Indent",
    outdent: "Outdent",
    link: "Link (Ctrl+K)",
    unlink: "Remove link",
    linkPh: "https://example.com or mailto:name@example.com",
    linkApply: "Apply",
    linkBad: "Use a link that starts with https:// or mailto:.",
    linkNeedsText: "Select some text first, then add the link.",
    image: "Add photo",
    imageUpload: "Upload from computer",
    imageLibrary: "From library",
    uploading: "Uploading {done} of {total}…",
    table: "Insert table",
    tableTools: "Table",
    addRow: "Add row",
    addColumn: "Add column",
    deleteRow: "Delete row",
    deleteColumn: "Delete column",
    deleteTable: "Delete table",
    divider: "Divider line",
    clear: "Clear formatting",
    source: "HTML source",
    visual: "Back to editor",
    sourceLabel: "HTML source of the long description",
    photoTools: "Photo",
    imageAlt: "Alt text",
    imageAltPh: "Describe the photo for people who can't see it",
    sizes: { s: "Small", m: "Medium", l: "Full width" },
    removeImage: "Remove photo",
    words: { one: "{count} word", other: "{count} words" },
    chars: "{count} characters",
    tooLong: "Too long: {size} of {max} characters of HTML. Shorten it or remove some formatting.",
    discardTitle: "You have unsaved changes.",
    discard: "Discard",
    keep: "Keep editing",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    remove: "Remove",
    previewLabel: "Long description preview",
  },
  installation: {
    title: "Installation services",
    lead: "Offer fitting or setup at checkout. Set a price per area; the buyer's address decides the price.",
    add: "Add service",
    newTitle: "Add installation service",
    editTitle: "Edit installation service",
    empty: "No installation services yet",
    emptyBody: "Create one, then pick it on a product. Buyers can add it at checkout.",
    name: "Service name, e.g. Wall mounting",
    description: "What is included (shown to buyers)",
    time: "Timing, e.g. Within 2 days",
    areas: "Prices by area",
    areasHelp: "The most specific area wins: municipality, then district, then province.",
    searchArea: "Search a province, district or municipality",
    noArea: "No area matches.",
    loadingAreas: "Loading areas…",
    elsewhere: "Offer it everywhere else too",
    elsewherePrice: "Price elsewhere",
    priceFor: "Price for {area}",
    removeArea: "Remove {area}",
    active: "Offered",
    inactive: "Switched off",
    products: { one: "{count} product", other: "{count} products" },
    areasCount: { one: "{count} area", other: "{count} areas" },
    from: "from {price}",
    edit: "Edit",
    delete: "Delete",
    deleteTitle: "Delete {name}?",
    deleteBody: "Buyers can no longer add it. Products that use it must be changed first.",
    inUse: "Products still offer this service. Switch it off, or change those products first.",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    saved: "Installation service saved",
    deleted: "Installation service deleted",
    needName: "Enter a name.",
    needPrice: "Add a price for at least one area, or offer it everywhere.",
    types: { province: "Province", district: "District", local_level: "Municipality" },
    provinceName: "{name} Province",
  },
  variants: {
    optionsTitle: "Options",
    optionsHelp: "Up to 3 options, such as Colour, Size and Fabric.",
    addOption: "Add option",
    optionName: "Option {n} name",
    optionValues: "Values",
    optionValuesHelp: "Separate values with commas.",
    removeOption: "Remove option",
    maxOptions: "You can use up to 3 options.",
    matrixTitle: "Variants",
    matrixHelp: "Untick combinations you don't sell. Only the ticked ones are created.",
    include: "Sell {title}",
    selectAll: "Tick all",
    selectNone: "Untick all",
    priceLabel: "Price",
    compareAtLabel: "Compare-at price",
    compareAtHelp: "The old price, shown crossed out. Must be higher than the price.",
    costLabel: "Cost",
    costHelp: "Only staff with cost permission see this.",
    skuLabel: "SKU",
    barcodeLabel: "Barcode",
    weightLabel: "Weight (grams)",
    priceRequired: "Enter a price.",
    noneSelected: "Tick at least one variant.",
    default: "Default",
    count: { one: "{count} of {total} combination", other: "{count} of {total} combinations" },
  },
  customFields: {
    help: "Ask buyers for details such as a name to engrave. A surcharge is added at checkout by the server.",
    add: "Add field",
    remove: "Remove field",
    labelLabel: "Question",
    typeLabel: "Answer type",
    types: {
      text: "Short text",
      textarea: "Long text",
      number: "Number",
      select: "One choice",
      multi: "Several choices",
      date: "Date",
      slot: "Time slot",
      image: "Photo upload",
    },
    required: "Required",
    surchargeLabel: "Surcharge per item",
    choicesLabel: "Choices",
    choicesHelp: "Separate choices with commas.",
    empty: "No personalisation fields.",
  },
  media: {
    title: "Media library",
    lead: "Photos for products, collections and your theme.",
    upload: "Upload photos",
    uploading: "Uploading {done} of {total}…",
    uploaded: { one: "{count} photo uploaded", other: "{count} photos uploaded" },
    uploadFailed: "{name} couldn't be uploaded.",
    typeNotAllowed: "{name} isn't a JPEG, PNG, WebP or AVIF image.",
    tooLarge: "{name} is larger than 15 MB.",
    pickFromLibrary: "Choose from library",
    pickTitle: "Choose photos",
    pickConfirm: "Add selected",
    remove: "Remove photo",
    altLabel: "Description for screen readers",
    altSave: "Save description",
    altSaved: "Description saved",
    storage: "Storage",
    storageValue: "{used} of {limit}",
    storageUnlimited: "{used} used",
    emptyTitle: "No photos yet",
    emptyBody:
      "Upload photos here or from a product. They're resized in your browser before upload.",
    gridLabel: "Photos",
    inUse: { one: "Used by {count} item", other: "Used by {count} items" },
    delete: "Delete photo",
    deleteTitle: "Delete this photo?",
    deleteBody: "It's removed from your store.",
    deleteInUseTitle: "This photo is in use",
    deleteInUseBody:
      "It's shown on {count} product or collection pages. Deleting removes it from them.",
    deleteAnyway: "Delete anyway",
    deleted: "Photo deleted",
    pending: "Processing",
    activationTitle: "Media storage is not active yet",
    activationBody: "Photo uploads start working once storage is switched on for this environment.",
    bytes: { b: "{n} B", kb: "{n} KB", mb: "{n} MB", gb: "{n} GB" },
    allMedia: "All media",
    storeFolders: "Store folders",
    productFolders: "Product folders",
    productFoldersHint:
      "Each product that uses photos or videos gets its own folder here, and it's removed when the product is deleted.",
    folderNav: "Folder",
    files: { one: "{count} file", other: "{count} files" },
    folders: {
      logos: "Logos",
      collections: "Collections",
      categories: "Categories",
      brands: "Brands",
    },
    folderEmpty: "This folder is empty",
    folderEmptyHint: {
      logos: "Add your store logo in Online store → Theme and it appears here.",
      collections: "Banner images, videos and share images you add to collections appear here.",
      categories: "Images and share images you add to categories appear here.",
      brands: "Brand logos and share images appear here.",
      product: "This product doesn't use any photos or videos now.",
    },
  },
  taxonomy: {
    searchLabel: "Search {list}",
    searchHint: "Search name or path",
    name: "Name",
    products: "Products",
    actions: "Actions",
    noMatch: "Nothing matches your search.",
  },
  categories: {
    title: "Categories",
    lead: "Group products for browsing. Each category has its own page and can hold subcategories.",
    add: "Add category",
    newTitle: "New category",
    newSubTitle: "New subcategory in {parent}",
    editTitle: "Edit category",
    close: "Close",
    // list
    listLabel: "Categories",
    searchLabel: "Search categories",
    searchPh: "Search by name or link…",
    statusLabel: "Show",
    status: { all: "All", active: "Active", hidden: "Hidden" },
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    dragHint: "Drag to change the order shoppers see.",
    dragHandle: "Drag to reorder {name}",
    reordered: "Order saved",
    showing: { one: "{count} category", other: "{count} categories" },
    noMatch: "No categories match.",
    subcategories: "Subcategories",
    subCount: { one: "{count} subcategory", other: "{count} subcategories" },
    noSubs: "Split this category into smaller groups when shoppers need a narrower way to browse.",
    addSub: "Add",
    addFirstSub: "Add the first subcategory",
    addSubTo: "Add a subcategory to {name}",
    expand: "Show the subcategories of {name}",
    active: "Active",
    hidden: "Hidden",
    notOnProduct: "Not on product pages",
    products: { one: "{count} product", other: "{count} products" },
    edit: "Edit",
    view: "View on store",
    hide: "Hide from store",
    show: "Show on store",
    shown: "{name} is on your store",
    hiddenNow: "{name} is hidden",
    delete: "Delete",
    deleteTitle: "Delete {name}?",
    deleteBody: "Products stay; they're just removed from this category, and its page is removed.",
    deleted: "Category deleted",
    hasChildren: "Move or delete the subcategories first.",
    emptyTitle: "No categories yet",
    emptyBody: "Add categories such as Men, Women or Shoes so shoppers can browse.",
    // editor
    secAbout: "Category",
    nameLabel: "Name",
    namePh: "e.g. Electronics, Clothing",
    parentLabel: "Inside",
    parentNone: "Top level",
    descriptionLabel: "Description",
    descriptionPh: "Optional short description shown on the category page…",
    imageLabel: "Image",
    imageHelp: "Shown on the category page and its tile.",
    altLabel: "Image description (alt text)",
    altPh: "What the image shows, for screen readers",
    secStore: "On your store",
    statusField: "Status",
    activeHelp: "Has its own page on your store",
    hiddenHelp: "No page; products stay in it",
    productPages: "On product pages",
    productPagesShow: "Shown",
    productPagesHide: "Hidden",
    productPagesHelp: "Product pages show and link their category.",
    linkLabel: "Link",
    secSeo: "Search engines",
    seoOptional: "optional",
    seoTitle: "Page title",
    seoDescription: "Description",
    seoKeywords: "Keywords",
    seoKeywordsPh: "Type a keyword and press Enter",
    seoImage: "Share image",
    seoImageHelp:
      "Shown when the link is shared. 1200 × 630 works best; the category image is used if empty.",
    seoPreview: "Search preview",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    saving: "Saving…",
    created: "Category added",
    saved: "Category saved",
    waitUploads: "Wait for uploads to finish.",
    discardTitle: "Discard changes?",
    discardBody: "Your edits to this category will be lost.",
    discard: "Discard",
    slugTaken: "A category with this name already exists here.",
    cycle: "A category can't be moved inside itself.",
    tooDeep: "Categories can be nested up to 7 levels.",
    stale: "Someone else changed this category. Close and open it again.",
  },
  brands: {
    title: "Brands",
    lead: "The brands you sell, each with its own page shoppers can browse.",
    add: "New brand",
    newTitle: "New brand",
    editTitle: "Edit brand",
    close: "Close",
    // list
    listLabel: "Brands",
    searchLabel: "Search brands",
    searchPh: "Search by name or link…",
    statusLabel: "Show",
    status: { all: "All", active: "Active", hidden: "Hidden" },
    sortLabel: "Order",
    sorts: {
      position: "Display order",
      name: "Name",
      created: "Newest",
      products: "Most products",
    },
    dragHint: "Drag rows to change the order shoppers see.",
    dragHandle: "Drag to reorder {name}",
    reordered: "Order saved",
    showing: { one: "{count} brand", other: "{count} brands" },
    noMatch: "No brands match.",
    colBrand: "Brand",
    colProducts: "Products",
    colStatus: "Status",
    colCreated: "Created",
    colActions: "Actions",
    active: "Active",
    hidden: "Hidden",
    products: { one: "{count} product", other: "{count} products" },
    edit: "Edit",
    view: "View on store",
    hide: "Hide from store",
    show: "Show on store",
    shown: "{name} is on your store",
    hiddenNow: "{name} is hidden",
    delete: "Delete",
    deleteTitle: "Delete {name}?",
    deleteBody: "Its page is removed from your store. This can't be undone.",
    deleted: "Brand deleted",
    inUse: "Remove this brand from its products first.",
    emptyTitle: "No brands yet",
    emptyBody: "Add the brands you sell so shoppers can browse and filter by them.",
    // editor
    secAbout: "Brand",
    nameLabel: "Brand name",
    namePh: "e.g. Nike, Samsung, Himalayan Java",
    descriptionLabel: "Short description",
    descriptionPh: "One or two lines shown on the brand page…",
    logoLabel: "Logo",
    logoHelp: "Square, 1024 × 1024 works best.",
    secStore: "On your store",
    statusField: "Status",
    activeHelp: "Has its own page on your store",
    hiddenHelp: "No page; products keep the brand",
    linkLabel: "Link",
    secSeo: "Search engines",
    seoOptional: "optional",
    seoTitle: "Page title",
    seoDescription: "Description",
    seoImage: "Share image",
    seoImageHelp:
      "Shown when the link is shared. 1200 × 630 works best; the logo is used if empty.",
    seoPreview: "Search preview",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    saving: "Saving…",
    created: "Brand added",
    saved: "Brand saved",
    waitUploads: "Wait for uploads to finish.",
    discardTitle: "Discard changes?",
    discardBody: "Your edits to this brand will be lost.",
    discard: "Discard",
    slugTaken: "A brand with this name already exists. Change the name slightly.",
    stale: "Someone else changed this brand. Close and open it again.",
  },
  collections: {
    title: "Collections",
    lead: "Group products into collections and banners for your home page, menus and offers.",
    add: "Create collection",
    newTitle: "New collection",
    editTitle: "Edit collection",
    close: "Close",
    // list
    listLabel: "Collections",
    searchLabel: "Search collections",
    searchPh: "Search by name or link…",
    statusLabel: "Show",
    status: { all: "All", active: "Active", hidden: "Hidden" },
    sortLabel: "Order",
    sorts: { position: "Display order", title: "Name", created: "Newest", updated: "Last edited" },
    dragHint: "Drag cards to change the order shoppers see.",
    dragHandle: "Drag to reorder {title}",
    reordered: "Order saved",
    showing: { one: "{count} collection", other: "{count} collections" },
    noMatch: "No collections match.",
    active: "Active",
    hidden: "Hidden",
    auto: "Automatic",
    manual: "Hand-picked",
    hasVideo: "Has a cover video",
    codeChip: "Code {code}",
    products: { one: "{count} product", other: "{count} products" },
    edit: "Edit",
    view: "View on store",
    hide: "Hide from store",
    show: "Show on store",
    shown: "{title} is on your store",
    hiddenNow: "{title} is hidden",
    delete: "Delete",
    deleteTitle: "Delete {title}?",
    deleteBody: "Products stay; only the collection and its page are removed.",
    deleted: "Collection deleted",
    emptyTitle: "No collections yet",
    emptyBody:
      "Collections such as New arrivals, Festive picks or Sale up to 50% group products for your home page and menus.",
    // editor
    secAbout: "Collection",
    titleLabel: "Name",
    titlePh: "e.g. Dashain sale",
    descriptionLabel: "Description",
    descriptionPh: "What's in this collection or offer…",
    linkLabel: "Link",
    secCover: "Cover",
    coverTip:
      "Shown at the top of the collection page and on its cards. A video plays instead of the photo.",
    coverPhoto: "Photo",
    coverVideo: "Video",
    coverUpload: "Upload photo",
    coverLibrary: "From library",
    coverRemove: "Remove photo",
    coverHelp: "Wide photos work best (3:1).",
    coverVideoHelp: "One video up to 50 MB.",
    coverVideoName: "Cover video",
    coverUploading: "Uploading…",
    secProducts: "Products",
    kindLabel: "How products are picked",
    kinds: { manual: "Pick by hand", rule: "Automatic" },
    kindLocked: "Can't be changed after the collection is created.",
    ruleHelp: "Products that match join and leave by themselves as you edit your catalog.",
    pickSearch: "Search products…",
    selected: "Selected ({count})",
    clearAll: "Clear all",
    noneSelected: "No products yet. Add them from the list below.",
    addProduct: "Add",
    removeProduct: "Remove {title}",
    moveProduct: "Drag to reorder {title}",
    allAdded: "Every product shown is already in the collection.",
    noProducts: "No products found.",
    unknownProduct: "Product not in the first 100 results",
    matchLabel: "Products must match",
    match: { all: "All conditions", any: "Any condition" },
    fields: {
      tag: "Has tag",
      category: "In category",
      brand: "Brand is",
      price_gte: "Price at least",
      price_lte: "Price at most",
      discounted: "Is on sale",
      title: "Name contains",
    },
    fieldLabel: "Condition",
    valueLabel: "Value",
    tagsPh: "Tags, comma separated",
    titleContainsPh: "Word in the product name",
    choose: "Choose…",
    addCondition: "Add condition",
    removeCondition: "Remove condition",
    ruleRequired: "Add at least one complete condition.",
    productsRequired: "Pick at least one product.",
    maxConditions: "Up to 10 conditions.",
    secStore: "On your store",
    statusField: "Status",
    activeHelp: "Visible on your store",
    hiddenHelp: "Hidden; products stay",
    sortField: "Product order",
    productSorts: {
      manual: "As arranged",
      newest: "Newest first",
      price_asc: "Price, low to high",
      price_desc: "Price, high to low",
      title: "Name, A to Z",
    },
    codeField: "Discount code",
    codeNone: "None",
    codeHelp: "Shown on the collection page so shoppers can use it at checkout.",
    codeInactive: "{code} (off)",
    secSeo: "Search engines",
    seoOptional: "optional",
    seoTitle: "Page title",
    seoDescription: "Description",
    seoKeywords: "Keywords",
    seoKeywordsPh: "Type a keyword and press Enter",
    seoImage: "Share image",
    seoImageHelp:
      "Shown when the link is shared. 1200 × 630 works best; the cover is used if empty.",
    seoPreview: "Search preview",
    seoCount: "{count} / {max}",
    seoSet: { one: "{count} field set", other: "{count} fields set" },
    seoDone: "Done",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    saving: "Saving…",
    created: "Collection created",
    saved: "Collection saved",
    waitUploads: "Wait for uploads to finish.",
    discardTitle: "Discard changes?",
    discardBody: "Your edits to this collection will be lost.",
    discard: "Discard",
    keepEditing: "Keep editing",
    slugTaken: "A collection with this name already exists. Change the name slightly.",
    stale: "Someone else changed this collection. Close and open it again.",
    loadFailed: "This collection couldn't be loaded.",
  },
  errors: {
    skuTaken: "This SKU is already used by another product.",
    barcodeTaken: "This barcode is already used by another product.",
    slugTaken: "Another product already uses this name's link. Change the name slightly.",
    mediaUnknown: "A photo isn't ready yet. Wait for uploads to finish.",
    costForbidden: "You don't have permission to set cost.",
    quota: "You've reached your plan's product limit.",
    combination: "Two variants have the same options.",
  },
} as const;
